module.exports = __webpack_public_path__ + "img/Monte_Kope_87.436adb3f.jpg";